import router from './router'
import useShippingInquiryStore from './store'
import ShippingInquiryMessages from './localization'

export default {
  router,
  useShippingInquiryStore,
  localization: ShippingInquiryMessages,
}
